import * as $ from 'jquery';
import lozad from 'lozad';
import { initTracker } from '../../../shared/js/tracker';
import { initShowcaseCore, initBackRedirect } from '../../../shared/js/showcase-core';
import { formatBankiRuTerm, initBankiRu } from '../../../shared/js/bankiru';
import { ready as apiReady } from '../../../shared/js/api-host';

if (process.env.NODE_ENV === 'development') {
  import('../../../shared/mocks/setup');
}

import '../scss/style.scss';
import './components/common';

const observer = lozad();
observer.observe();

$(function () {
  Promise.resolve(apiReady).then(() => {
    initShowcaseCore({
      clickSelector: '.offers__item',
      template,
      showPreloader,
      hidePreloader,
    });

    function applyPersonalization(fields) {
      if (!fields) return;
      const { name, amount, fullamount } = fields;
      const $default = $('[data-default-title]');
      const $personal = $('[data-personalized-title]');

      // Fill known fields if present in DOM
      if (typeof name === 'string' && name) {
        $('[data-field-name]').text(String(name));
      }
      if (typeof amount === 'number' && !Number.isNaN(amount)) {
        const fmt = amount.toLocaleString('ru-RU').replace(/\s/g, '.');
        $('[data-field-amount]').text(fmt);
      }
      if (typeof fullamount === 'number' && !Number.isNaN(fullamount)) {
        const fmtf = fullamount.toLocaleString('ru-RU').replace(/\s/g, '.');
        $('[data-field-fullamount]').text(fmtf);
      }

      // If there is an explicit personalized block placeholder, toggle it when we have enough data
      const canShowPersonal = ($personal.length > 0) && (
        ($('[data-field-name]').length && $('[data-field-amount]').length && typeof amount === 'number')
      );
      if (canShowPersonal) {
        $default.hide();
        $personal.show();
      }
    }

    try {
      const fields = window.__visitData && window.__visitData.fields;
      if (fields) applyPersonalization(fields);
    } catch (_) {}

    window.addEventListener('visit:tracked', (e) => {
      const fields = e && e.detail && e.detail.fields;
      applyPersonalization(fields);
    });

    // Banki.ru integration — after visit/track so bankiRuInRollout is set
    initBankiRu({
      renderCard: bankiruRenderCard,
      wrapperOpen: '<div class="offers__items">',
      wrapperClose: '</div>',
    });
  });
});

initBackRedirect();

// B24-92552: возврат из bfcache — визит уже закрыт (showcase_exit отправлен),
// трекер и Banki.ru не переинициализируются. Перезагрузка получает новый визит.
window.addEventListener('pageshow', (e) => {
  if (e.persisted) location.reload();
});

function showPreloader(currLink) {
  $(currLink).css('pointer-events', 'none');
  $(currLink).find('.offer-button > .btn-text').addClass('is-hidden');
  $(currLink).find('.offer-button > .btn-loader').addClass('is-visible');
}

function hidePreloader(currLink) {
  $(currLink).css('pointer-events', 'auto');
  $(currLink).find('.offer-button > .btn-text').removeClass('is-hidden');
  $(currLink).find('.offer-button > .btn-loader').removeClass('is-visible');
}

function template(offer) {
  return `
    <div class="offers__item__wrapper">
      <div
        class="offers__item"
        ${!offer.isBankiru ? `data-offer-id="${offer.id}"` : ''}
        ${offer.isBankiru && (offer.productId || offer.productCode) ? `data-product-id="${offer.productId || offer.productCode}"` : ''}
        ${offer.offerVisitId ? `data-offer-visit-id="${offer.offerVisitId}"` : ''}
      >
        <div class="offers__item-top">
          <div class="offers__item-logo">
            <img src="${offer.image}" alt="">
          </div>
          <div class="offers__item-tag">
            <span>${offer.tag ? offer.tag : getRandomTag()}</span>
          </div>
        </div>
        <div class="offers__item-details">
          <div class="offers__item-details-item offers__item-details-item_left">
            ${offer.termEnd ? `<span>${offer.isBankiru ? `Срок ${offer.termEnd}` : `До ${offer.termEnd}`}</span>` : ''}
            ${offer.isBankiru ? '' : '<span>Первый заем <br> бесплатно</span>'}
          </div>
          <div class="offers__item-details-item offers__item-details-item_right">
            <span class="available">Доступно</span>
            ${offer.amount ? `<span class="price">${offer.isBankiru ? '' : 'до '}${offer.amount.toLocaleString('ru-RU')} ₽</span>` : ''}
          </div>
        </div>
        <button class="btn btn-full btn-primary offer-button ${offer.isBankiru ? 'bankiru-card__btn' : ''}" aria-label="Получить деньги">
          <span class="btn-text">Получить деньги</span>
          <span class="btn-loader"></span>
        </button>
      </div>
      ${offer.expireHtml ? offer.expireHtml : ''}
    </div>
  `;
}

function bankiruRenderCard(p) {
  const term = formatBankiRuTerm(p.approvalTermMax, p.approvalTermTypeMax);
  const offer = {
    id: p.productCode,
    image: p.partnerLogo || '',
    amount: p.approvalAmountMax,
    termEnd: term,
    tag: '100% одобрение',
    isBankiru: true,
    productCode: p.productCode,
    productId: p.productId || p.productCode,
    expireHtml: p.approvalTermExpire
      ? `<div class="bankiru-card__expire" data-expire="${p.approvalTermExpire}"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.5C5.90111 6.5 5.80444 6.47068 5.72221 6.41573C5.63999 6.36079 5.5759 6.2827 5.53806 6.19134C5.50022 6.09998 5.49031 5.99945 5.50961 5.90245C5.5289 5.80546 5.57652 5.71637 5.64645 5.64645C5.71637 5.57652 5.80546 5.5289 5.90245 5.50961C5.99945 5.49031 6.09998 5.50022 6.19134 5.53806C6.2827 5.5759 6.36079 5.63999 6.41573 5.72221C6.47068 5.80444 6.5 5.90111 6.5 6C6.5 6.13261 6.44732 6.25979 6.35355 6.35355C6.25979 6.44732 6.13261 6.5 6 6.5ZM10 9.5C9.90111 9.5 9.80444 9.52932 9.72221 9.58426C9.63999 9.63921 9.5759 9.7173 9.53806 9.80866C9.50022 9.90002 9.49031 10.0006 9.50961 10.0975C9.5289 10.1945 9.57652 10.2836 9.64645 10.3536C9.71637 10.4235 9.80546 10.4711 9.90245 10.4904C9.99944 10.5097 10.1 10.4998 10.1913 10.4619C10.2827 10.4241 10.3608 10.36 10.4157 10.2778C10.4707 10.1956 10.5 10.0989 10.5 10C10.5 9.86739 10.4473 9.74021 10.3536 9.64645C10.2598 9.55268 10.1326 9.5 10 9.5ZM15 8C15 8.6525 14.5306 9.14187 14.1163 9.57375C13.8806 9.82 13.6369 10.0737 13.545 10.2969C13.46 10.5013 13.455 10.84 13.45 11.1681C13.4406 11.7781 13.4306 12.4694 12.95 12.95C12.4694 13.4306 11.7781 13.4406 11.1681 13.45C10.84 13.455 10.5013 13.46 10.2969 13.545C10.0737 13.6369 9.82 13.8806 9.57375 14.1163C9.14187 14.5306 8.6525 15 8 15C7.3475 15 6.85812 14.5306 6.42625 14.1163C6.18 13.8806 5.92625 13.6369 5.70312 13.545C5.49875 13.46 5.16 13.455 4.83187 13.45C4.22187 13.4406 3.53062 13.4306 3.05 12.95C2.56937 12.4694 2.55937 11.7781 2.55 11.1681C2.545 10.84 2.54 10.5013 2.455 10.2969C2.36312 10.0737 2.11937 9.82 1.88375 9.57375C1.46937 9.14187 1 8.6525 1 8C1 7.3475 1.46937 6.85812 1.88375 6.42625C2.11937 6.18 2.36312 5.92625 2.455 5.70312C2.54 5.49875 2.545 5.16 2.55 4.83187C2.55937 4.22187 2.56937 3.53062 3.05 3.05C3.53062 2.56937 4.22187 2.55937 4.83187 2.55C5.16 2.545 5.49875 2.54 5.70312 2.455C5.92625 2.36312 6.18 2.11937 6.42625 1.88375C6.85812 1.46937 7.3475 1 8 1C8.6525 1 9.14187 1.46937 9.57375 1.88375C9.82 2.11937 10.0737 2.36312 10.2969 2.455C10.5013 2.54 10.84 2.545 11.1681 2.55C11.7781 2.55937 12.4694 2.56937 12.95 3.05C13.4306 3.53062 13.4406 4.22187 13.45 4.83187C13.455 5.16 13.46 5.49875 13.545 5.70312C13.6369 5.92625 13.8806 6.18 14.1163 6.42625C14.5306 6.85812 15 7.3475 15 8ZM6 7.5C6.29667 7.5 6.58668 7.41203 6.83336 7.2472C7.08003 7.08238 7.27229 6.84811 7.38582 6.57403C7.49935 6.29994 7.52906 5.99834 7.47118 5.70736C7.4133 5.41639 7.27044 5.14912 7.06066 4.93934C6.85088 4.72956 6.58361 4.5867 6.29264 4.52882C6.00166 4.47094 5.70006 4.50065 5.42597 4.61418C5.15189 4.72771 4.91762 4.91997 4.7528 5.16664C4.58797 5.41332 4.5 5.70333 4.5 6C4.5 6.39782 4.65804 6.77936 4.93934 7.06066C5.22064 7.34196 5.60218 7.5 6 7.5ZM10.8538 5.85375C10.9002 5.8073 10.9371 5.75214 10.9622 5.69145C10.9873 5.63075 11.0003 5.5657 11.0003 5.5C11.0003 5.4343 10.9873 5.36925 10.9622 5.30855C10.9371 5.24786 10.9002 5.1927 10.8538 5.14625C10.8073 5.09979 10.7521 5.06294 10.6914 5.0378C10.6308 5.01266 10.5657 4.99972 10.5 4.99972C10.4343 4.99972 10.3692 5.01266 10.3086 5.0378C10.2479 5.06294 10.1927 5.09979 10.1462 5.14625L5.14625 10.1462C5.09979 10.1927 5.06294 10.2479 5.0378 10.3086C5.01266 10.3692 4.99972 10.4343 4.99972 10.5C4.99972 10.5657 5.01266 10.6308 5.0378 10.6914C5.06294 10.7521 5.09979 10.8073 5.14625 10.8538C5.24007 10.9476 5.36732 11.0003 5.5 11.0003C5.5657 11.0003 5.63075 10.9873 5.69145 10.9622C5.75214 10.9371 5.8073 10.9002 5.85375 10.8538L10.8538 5.85375ZM11.5 10C11.5 9.70333 11.412 9.41332 11.2472 9.16665C11.0824 8.91997 10.8481 8.72771 10.574 8.61418C10.2999 8.50065 9.99834 8.47094 9.70736 8.52882C9.41639 8.5867 9.14912 8.72956 8.93934 8.93934C8.72956 9.14912 8.5867 9.41639 8.52882 9.70736C8.47094 9.99834 8.50065 10.2999 8.61418 10.574C8.72771 10.8481 8.91997 11.0824 9.16665 11.2472C9.41332 11.412 9.70333 11.5 10 11.5C10.3978 11.5 10.7794 11.342 11.0607 11.0607C11.342 10.7794 11.5 10.3978 11.5 10Z" fill="white"/></svg> Истекает через: <span class="bankiru-card__countdown"></span></div>`
      : ''
  };

  return template(offer);
}

function getRandomTag() {
  const tags = ['Без справок', 'Первый займ - бесплатно', 'Без переплат'];
  return tags[Math.floor(Math.random() * tags.length)];
}

initTracker();
